(function() {
  function init() {
    var sections = document.querySelectorAll('.bd-collapsible-tabs');
    sections.forEach(function(section) {
      if (section.dataset.bdFindShowroomInit === 'true') return;
      section.dataset.bdFindShowroomInit = 'true';

      var tabs = section.querySelectorAll('.bd-find-showroom__tab');
      var panels = section.querySelectorAll('.bd-find-showroom__panel');
      if (!tabs.length || !panels.length) return;

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var key = this.getAttribute('data-location-key');

          tabs.forEach(function(t) {
            t.classList.remove('bd-real-spaces__tab--active');
            t.setAttribute('aria-selected', 'false');
          });

          panels.forEach(function(p) {
            p.classList.remove('bd-find-showroom__panel--active');
            p.hidden = true;
          });

          this.classList.add('bd-real-spaces__tab--active');
          this.setAttribute('aria-selected', 'true');

          var panel = section.querySelector('.bd-find-showroom__panel[data-location-key="' + key + '"]');
          if (panel) {
            panel.classList.add('bd-find-showroom__panel--active');
            panel.hidden = false;
          }
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
